import PropTypes from 'prop-types'

import { ControlFlags } from '../../models/common/control-flags-enum'
import { currentDriverObjectAssignmentPropType } from './current-driver-object-assignment-prop-type'
import { currentWorkStatePropType } from './current-work-state-prop-type'

/**
 * @readonly
 * @enum {string}
 */
export const CONTROL_FLAGS = {
    [ControlFlags.ACTIVATE_DRIVER]: ControlFlags.ACTIVATE_DRIVER,
    [ControlFlags.ASSIGN_OBJECT_MANUALLY]: ControlFlags.ASSIGN_OBJECT_MANUALLY,
    [ControlFlags.CHANGE_DRIVER_GROUP_MEMBERSHIP]: ControlFlags.CHANGE_DRIVER_GROUP_MEMBERSHIP,
    [ControlFlags.DEACTIVATE_DRIVER]: ControlFlags.DEACTIVATE_DRIVER,
    [ControlFlags.DELETE_DRIVER]: ControlFlags.DELETE_DRIVER,
    [ControlFlags.EDIT_DRIVER]: ControlFlags.EDIT_DRIVER,
    [ControlFlags.UNASSIGN_OBJECT_MANUALLY]: ControlFlags.UNASSIGN_OBJECT_MANUALLY
}
Object.freeze(CONTROL_FLAGS)

/**
 * This is the Driver type definition for the REST model.
 *
 * @typedef {Object} Driver
 * @property {boolean} [active=false]           - Defines whether the driver is active or inactive.
 * @property {string} [citizenServiceNumber]    - The citizen service number (BSN) of the driver.
 * @property {string} [city]                    - The city of the driver address.
 * @property {string} [company]                 - The company of the driver.
 * @property {CONTROL_FLAGS} [controlFlags]     - Flags which indicate what actions are possible with the driver.
 *                                                Possible flags: [editDriver, activateDriver, deactivateDriver].
 * @property {string} [countryCode]             - The country code of the driver address.
 * @property {string} [description]             - Additional information about the driver.
 * @property {string} [driverId]                - The identifier of the driver.
 * @property {string} [email]                   - The email of the driver.
 * @property {string} [mobilePhone]             - The mobile phone of the driver.
 * @property {string} [name]                    - The name of the driver.
 * @property {string} [number]                  - The number of the driver. Unique within an account.
 * @property {CurrentDriverObjectAssignment} [objectAssignment] - The current driver object assignment.
 * @property {string} [pin]                     - The PIN that identifies the driver.
 * @property {string} [privatePhone]            - The private phone of the driver.
 * @property {string} [source]                  - The creation source of the driver.
 * @property {string} [street]                  - The street of the driver address.
 * @property {CurrentWorkState} [workState]     - The work state of the driver.
 * @property {string} [zip]                     - The zip code of the driver address.
 */
export const driverPropType = PropTypes.shape({
    active: PropTypes.bool,
    citizenServiceNumber: PropTypes.string,
    city: PropTypes.string,
    company: PropTypes.string,
    controlFlags: PropTypes.arrayOf(PropTypes.oneOf(Object.values(CONTROL_FLAGS))),
    countryCode: PropTypes.string,
    description: PropTypes.string,
    driverId: PropTypes.string,
    email: PropTypes.string,
    mobilePhone: PropTypes.string,
    name: PropTypes.string,
    number: PropTypes.string,
    objectAssignment: currentDriverObjectAssignmentPropType,
    pin: PropTypes.string,
    privatePhone: PropTypes.string,
    source: PropTypes.string,
    street: PropTypes.string,
    workState: currentWorkStatePropType,
    zip: PropTypes.string
})
